module.exports = __webpack_public_path__ + "fromGroomToFather-we-w.6875a426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToFather-we-w.jpg
// module id = kUhv
// module chunks = 0